import { User } from '@graphics/gfx-common/dist/types'
import { IInitAction } from './init'
import { UserDateType } from './date'
import { ISelectInput } from './pack'
import { ICapability } from './capability'

// Action types
export enum types {
  CREATE_GROUP__STARTED = 'CREATE_GROUP__STARTED',
  CREATE_GROUP__SUCCESS = 'CREATE_GROUP__SUCCESS',
  CREATE_GROUP__FAILURE = 'CREATE_GROUP__FAILURE',
  GET_GROUP_BY_ID__STARTED = 'GET_GROUP_BY_ID__STARTED',
  GET_GROUP_BY_ID__SUCCESS = 'GET_GROUP_BY_ID__SUCCESS',
  GET_GROUP_BY_ID__FAILURE = 'GET_GROUP_BY_ID__FAILURE',
  UPDATE_GROUP__STARTED = 'UPDATE_GROUP__STARTED',
  UPDATE_GROUP__SUCCESS = 'UPDATE_GROUP__SUCCESS',
  UPDATE_GROUP__FAILURE = 'UPDATE_GROUP__FAILURE',
  DELETE_GROUP__STARTED = 'DELETE_GROUP__STARTED',
  DELETE_GROUP__SUCCESS = 'DELETE_GROUP__SUCCESS',
  DELETE_GROUP__FAILURE = 'DELETE_GROUP__FAILURE',
  CLEAR_GROUP_DATA = 'CLEAR_GROUP_DATA',
}

export interface ICreateGroupAction {
  type: types.CREATE_GROUP__STARTED
  groupData: IGroupDetailed
}

export interface ICreateGroupSuccessAction {
  type: types.CREATE_GROUP__SUCCESS
  groupData: IGroupDetailed
  message: string
}

export interface IFailureAction {
  type:
    | types.CREATE_GROUP__FAILURE
    | types.GET_GROUP_BY_ID__FAILURE
    | types.UPDATE_GROUP__FAILURE
    | types.DELETE_GROUP__FAILURE
  message: string
}

export interface IGetGroupByIdAction {
  type: types.GET_GROUP_BY_ID__STARTED
  groupId: string
}

export interface IGetGroupByIdSuccessAction {
  type: types.GET_GROUP_BY_ID__SUCCESS
  groupData: IGroupDetailed
}

export interface IUpdateGroupAction {
  type: types.UPDATE_GROUP__STARTED
  groupData: IGroupDetailed
  initialCapabilitiesIds?: string[]
}

export interface IUpdateGroupSuccessAction {
  type: types.UPDATE_GROUP__SUCCESS
  groupData: IGroupDetailed
  message: string
}

export interface IDeleteGroupAction {
  type: types.DELETE_GROUP__STARTED
  groupId: string
}

export interface IDeleteGroupSuccessAction {
  type: types.DELETE_GROUP__SUCCESS
  message: string
}

export interface IClearGroupDataAction {
  type: types.CLEAR_GROUP_DATA
}

export type GroupActionsType =
  | ICreateGroupAction
  | ICreateGroupSuccessAction
  | IFailureAction
  | IGetGroupByIdAction
  | IGetGroupByIdSuccessAction
  | IUpdateGroupAction
  | IUpdateGroupSuccessAction
  | IDeleteGroupAction
  | IDeleteGroupSuccessAction
  | IClearGroupDataAction
  | IInitAction

// Reducer types
export interface IRole {
  editors: User
}

export interface IRoleInput extends ISelectInput {
  id: string
}

export interface IGroup extends UserDateType {
  isLoading?: boolean
  description?: string | null
  name: string
  order: number
  shortTitle: string
  title: string
  hidden: boolean
}

export interface IGroupDetailed extends IGroup {
  message?: string
  capabilities: Array<{ id: string; title?: string } | ICapability>
  maxFileSizeMb: number
  roles?: IRole
}

export interface IGroupInput extends IGroupDetailed {
  editorRole?: IRoleInput
}
